import * as url from 'url';
import * as qs from 'qs';
import { ROUTES, ROUTES_CONSTANTS } from '../const';
import { CONTEXT_PATH } from '../config_module';

export function getParameterByName(name, uri) {
  if (typeof uri !== 'string') {
    // The query string can only be parsed if it is a string, otherwise will throw a `TypeError`
    return undefined;
  }

  const query = qs.parse(url.parse(uri).query);

  return query[name];
}

export function getUrlFromTabView(view, classroomId) {
  switch (view.key) {
    case 'mycontent':
      return `${ROUTES.CLASSROOM}/${classroomId}`;
    case 'assignments':
      return `${ROUTES.CLASSROOM}/${classroomId}/tasks`;
    case 'students':
      return `${ROUTES.CLASSROOM}/${classroomId}/students`;
    case 'discussions':
      return `${ROUTES.CLASSROOM}/${classroomId}/discussions`;
    case 'gradebook':
      return `${ROUTES.CLASSROOM}/${classroomId}/gradebook`;
    case 'studentAnnotations':
      return `${ROUTES.CLASSROOM}/${classroomId}/annotations`;
    case 'library':
      return `${ROUTES.CLASSROOM}/${classroomId}/library`;
    case 'classroomBasicAnalytics':
      return `${ROUTES.CLASSROOM}/${classroomId}/analytics`;
    case 'classroom':
      return `${CONTEXT_PATH}/home`;
    case 'homeAssignments':
      return `${CONTEXT_PATH}/tasks`;
    case 'homeLibrary':
      return `${CONTEXT_PATH}/library`;
    default:
      return null;
  }
}

export function getClassroomTo(classroomId, routeConstant) {
  switch (routeConstant) {
    case ROUTES_CONSTANTS.CLASSROOM_WORKSPACE_LIBRARY:
    case ROUTES_CONSTANTS.CLASSROOM_WORKSPACE_LIBRARY_STUDENT:
    case ROUTES_CONSTANTS.MY_CONTENTS:
      return `${ROUTES.CLASSROOM}/${classroomId}`;
    case ROUTES_CONSTANTS.CLASSROOM_STUDENTS:
      return `${ROUTES.CLASSROOM}/${classroomId}/students`;
    case ROUTES_CONSTANTS.ASSIGNMENTS:
      return `${ROUTES.CLASSROOM}/${classroomId}/tasks`;
    case ROUTES_CONSTANTS.CLASSROOM_ANALYTICS:
      return `${ROUTES.CLASSROOM}/${classroomId}/analytics`;
    case ROUTES_CONSTANTS.GRADEBOOK:
      return `${ROUTES.CLASSROOM}/${classroomId}/gradebook`;
    case ROUTES_CONSTANTS.DISCUSSIONS:
      return `${ROUTES.CLASSROOM}/${classroomId}/discussions`;
    case ROUTES_CONSTANTS.STUDENT_ANNOTATIONS:
      return `${ROUTES.CLASSROOM}/${classroomId}/annotations`;
    case ROUTES_CONSTANTS.CLASSROOM_LIBRARY:
      return `${ROUTES.CLASSROOM}/${classroomId}/library`;
    default:
      return '';
  }
}
